export default __webpack_public_path__ + "static/media/product-2.533367b0.jpg";